import IconUser from '@/shared/assets/icons/icon-user.svg?react';
import { useAuth } from '@/shared/hooks/useAuth/useAuth';
import { EmployeeRole } from '@/shared/ui';
import { Stack } from '@/shared/ui/Stack/Stack';

export const AppUserProfile = () => {
  const { profile } = useAuth();

  const fullName = profile?.full_name;

  return (
    <Stack direction="horizontal" className="items-center gap-x-4">
      <div className="bg-grey-4d5761 flex size-11 items-center justify-center rounded-full">
        <IconUser />
      </div>
      <Stack className="gap-y-.5">
        <div className="w-[185px] truncate leading-[20px] font-semibold uppercase">
          {fullName}
        </div>
        <div
          title={profile?.role?.label ?? ''}
          className="text-12 w-[185px] truncate leading-[18px] text-[#6c737f]"
        >
          <EmployeeRole role={profile?.role?.label ?? ''} />
        </div>
      </Stack>
    </Stack>
  );
};
